import { useEffect, useState, useTransition } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { RequestFetch } from "../config/requestFetch";
import Cookies from "universal-cookie";
import { httpConfig } from "../httpConfig";
import moment from "moment";
import { searchlistLogbookdetail } from "../config/searchingdata";
import {
  encodeAndStoreData,
  getdataAndDecodeStoreData,
} from "../config/encodelocalstorage";
import ModalConfig from "../modal/modalConfig";
import { Icon } from "@iconify/react";

const Logbook = () => {
  const { topic, subject } = useParams();
  const navigat = useNavigate();

  const cookie = new Cookies();
  const usertoken = cookie.get("tokenEstimate");
  const http = httpConfig();

  const [hnlogbook, setHNlogbook] = useState("");
  const [datelogbook, setDatelogbook] = useState("");
  const [supervisor, setSupervisor] = useState("");
  const [epa, setEpa] = useState(false);
  const [link, setLink] = useState("");
  const [file, setFile] = useState([]);

  const [listlogbookFilter, setListlogbookFilter] = useState("");

  const [dataAdvisor, setDataAdvisor] = useState([]);

  const [dataforTableshow, setDataforTableshow] = useState(() => {
    if (localStorage.getItem(`${subject}`)) {
      console.log(getdataAndDecodeStoreData(`${subject}`));
      return getdataAndDecodeStoreData(`${subject}`);
    } else {
      return [];
    }
  });
  const [dataforsearchshow, setDataforsearchshow] = useState([]);
  const [dataModalshow, setDataModalshow] = useState({});

  const getdocId = (id) => {
    return document.getElementById(id);
  };

  function handleGetAdvisorDATA() {
    let request = RequestFetch("POST", { doctorid: "0" }, usertoken);
    fetch(`${http}/advisorChoice`, request).then((res) =>
      res.json().then((data) => {
        let arrdata = [];
        data.map((data) => {
          arrdata.push({ ttl: data.ttl, name: data.name, lname: data.lname });
        });
        setDataAdvisor(arrdata);
      })
    );
  }

  function handleSpanOntop(id, status) {
    let input = getdocId(id);
    if (status) {
      input.style.animation = "spanboxOntop 0.5s normal";
      setTimeout(() => {
        input.style.top = "-60%";
        input.style.color = "#2E3136";
        input.style.display = "block";
      }, 50);
    } else if (!status) {
      input.style.animation = "spanboxNormal 0.5s normal";
      setTimeout(() => {
        input.style.top = "0";
        input.style.color = "#CFCAC7";
        input.style.display = "none";
      }, 50);
    }
  }

  function handleopenDropdownSupervisor() {
    getdocId("box-dropdownInputsupervisor").style.display = "block";
  }

  function handleopenInputlogbook(animation, input, mode) {
    let boxAnimation = getdocId(animation);
    let boxShowinput = getdocId(input);
    let btnUP = getdocId("btn-downOpenlogbook");
    let btnDown = getdocId("btn-upCloselogbook");
    let boxsubmit = getdocId("submitcancleBTN");
    if (mode) {
      boxAnimation.style.animation = "tryTohight 0.5s normal";
      setTimeout(() => {
        boxAnimation.style.height = "auto";
        boxShowinput.style.display = "block";
        btnUP.style.display = "none";
        btnDown.style.display = "block";
        boxsubmit.style.display = "block";
      }, 250);
    } else {
      boxShowinput.style.display = "none";
      boxsubmit.style.display = "none";
      boxAnimation.style.animation = "tryDownhight 0.5s normal";
      setTimeout(() => {
        boxAnimation.style.height = "auto";
        btnUP.style.display = "block";
        btnDown.style.display = "none";
      }, 50);
    }
  }

  function handleClearInputLogbook() {
    setEpa(false);
    setHNlogbook("");
    setDatelogbook("");
    setSupervisor("");
    setLink("");
    setFile([]);

    handleSpanOntop("borderspanTop-HN", false);
    handleSpanOntop("borderspanTop-supervisor", false);
    handleSpanOntop("borderspanTop-link", false);
    handleSpanOntop("borderspanTop-file", false);
  }

  function handleSubmitlogbook(e) {
    e.preventDefault();
    let countdata = dataforTableshow.length;

    if (hnlogbook && datelogbook && supervisor) {
      let dataDATE = moment(datelogbook).format("DD/MM/YYYY");
      if (epa) {
        // console.log("อันนี้มี EPA");
        let objectTosetdataEpa = {
          no: countdata + 1,
          hn: hnlogbook,
          date: dataDATE,
          supervisor: supervisor,
          epa: true,
          link: link,
          file: file[0].name,
        };
        let arrdataepa = dataforTableshow;
        arrdataepa.push(objectTosetdataEpa);
        let sortarrdataepa = arrdataepa.sort((a, b) => {
          let dateA = new Date(a.date.split("/").reverse().join("-"));
          let dateB = new Date(b.date.split("/").reverse().join("-"));
          return dateA - dateB;
        });
        setDataforTableshow(sortarrdataepa);
        encodeAndStoreData(subject.toLowerCase(), sortarrdataepa);
      } else {
        let objectTosetdata = {
          no: countdata + 1,
          hn: hnlogbook,
          date: dataDATE,
          supervisor: supervisor,
          link: "",
          file: "",
        };
        console.log("อันนี้ไม่มี EPA", objectTosetdata);
        let arrdata = dataforTableshow;
        arrdata.push(objectTosetdata);
        let sortdataarr = arrdata.sort((a, b) => {
          let dateA = new Date(a.date.split("/").reverse().join("-"));
          let dateB = new Date(b.date.split("/").reverse().join("-"));
          return dateA - dateB;
        });
        setDataforTableshow(sortdataarr);
        encodeAndStoreData(subject.toLowerCase(), sortdataarr);
      }
      handleClearInputLogbook();
    } else {
      return;
    }
  }

  function AcontentShowinfomodal() {
    return (
      <div className="bodycontent-ModalinfomationLogbook">
        <div className="title-ModalinfomationLogbook">
          <div className="box-title-modalLogbook">
            <span className="span-title-modallogbook">
              {"ข้อมูลบันทึก LOGBOOK"}
            </span>
          </div>
          <div className="box-title-modalLogbook">
            <button
              type="button"
              className="icon-close-Modallogbook"
              onClick={() => {
                getdocId("modalbox-infomationLogbook").style.display = "none";
              }}
            >
              <Icon icon={"iconamoon:close-bold"} width={35} height={35}></Icon>
            </button>
          </div>
        </div>
        <div className="contentinfomation-ModalinfomationLogbook">
          <div className="aboxbodyinfo-listlogbook">
            <div className="box-info-listlogbook headboxinfo-listlogbook">
              {dataModalshow.epa ? (
                <>
                  <span>{"EPA"}</span>
                  <span>{dataModalshow.epa}</span>
                </>
              ) : (
                <>
                  <span>{"HN"}</span>
                  <span>{dataModalshow.hn}</span>
                </>
              )}
            </div>
            {dataModalshow.epa ? (
              <div className="box-info-listlogbook">
                <span className="headinfo-infolistlogbook">{"HN"}</span>
                <span className="textinfo-infolistlogbook">
                  {dataModalshow.hn}
                </span>
              </div>
            ) : (
              ""
            )}
            <div className="box-info-listlogbook">
              <span className="headinfo-infolistlogbook">{"date"}</span>
              <span className="textinfo-infolistlogbook">
                {dataModalshow.date}
              </span>
            </div>
            <div className="box-info-listlogbook">
              <span className="headinfo-infolistlogbook">{"supervisor"}</span>
              <span className="textinfo-infolistlogbook">
                {dataModalshow.supervisor}
              </span>
            </div>
            {dataModalshow.link ? (
              <div className="box-info-listlogbook">
                <span className="headinfo-infolistlogbook">{"link"}</span>
                <span className="textinfo-infolistlogbook">
                  {dataModalshow.link}
                </span>
              </div>
            ) : (
              ""
            )}
            {dataModalshow.file ? (
              <div className="box-info-listlogbook">
                <span className="headinfo-infolistlogbook">{"file"}</span>
                <span className="textinfo-infolistlogbook">
                  {dataModalshow.file}
                </span>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="footer-ModalinfomationLogbook">
          <button
            className="btn-trash"
            type="button"
            disabled={dataModalshow.epa}
            style={dataModalshow.epa?{color:"#A4A3A1"}:{color:"#AA7C7A"}}
            onClick={()=>{
              console.log("TEST")
            }}
          >
            <i className="bi-trash"></i>
          </button>
        </div>
      </div>
    );
  }

  function handleOpenModalinfomation(info) {
    // console.log("ตัวboxของโมเดล ====>", getdocId);
    getdocId("modalbox-infomationLogbook").style.display = "block";
    setDataModalshow(info);
  }

  useEffect(() => {
    if (!dataforTableshow[0]) return;
    encodeAndStoreData(subject, dataforTableshow);
  }, [dataforTableshow]);

  window.onclick = function (e) {
    if (e.target !== document.getElementsByName("supervisor_phaco")[0]) {
      try {
        // handleopenDropdownSupervisor(false);
        getdocId("box-dropdownInputsupervisor").style.display = "none";
      } catch (error) {
        return;
      }
    }
  };

  useEffect(() => {
    handleGetAdvisorDATA();
  }, []);
  return (
    <div className="bodycontent-phaco">
      <div className="navmenu-phaco">
        <div className="title-listmenuTopic">
          <div
            className="boxtitle-iconleft"
            onClick={() => {
              navigat(`/listmenu_topic/${topic}`);
            }}
          >
            <i className="title-iconleft bi-arrow-left-circle"></i>
          </div>
          <div className="boxtitle-textTopic">
            <span>{subject.split("-").reverse().join("/")}</span>
          </div>
          <div className="box-closeTohomepage">
            <button
              type="button"
              className="btn-closeTohomepage"
              onClick={() => {
                navigat("/resident_home");
              }}
            >
              <i className="bi-x-circle"></i>
            </button>
          </div>
        </div>
      </div>
      <div className="content-phaco">
        <div className="box-inputform-logbook">
          <form
            className="formcontent-logbook"
            onSubmit={(e) => {
              handleSubmitlogbook(e);
              handleClearInputLogbook();
            }}
          >
            <div className="title-nav-form">
              <span className="span-titleForm">{`LOGBOOK`}</span>
            </div>
            <hr></hr>
            <div className="box-inputinfo-logbook">
              <div
                className="divAnimation-infonormal-logbook"
                id="animationLogbook"
              >
                <div className="div-infonormal-logbook" id="boxinputLogbook">
                  <div className="inputbox-logbook">
                    <span
                      className="textBorder-logbook"
                      id={`borderspanTop-HN`}
                    >
                      {"HN"}
                    </span>
                    <input
                      type="text"
                      className="inputtext-phaco"
                      placeholder="HN"
                      value={hnlogbook}
                      maxLength={7}
                      onChange={(e) => {
                        setHNlogbook(e.target.value);
                      }}
                      onFocus={(e) => {
                        handleSpanOntop("borderspanTop-HN", true);
                        e.target.select();
                      }}
                      onBlur={(e) => {
                        getdocId("box-dropdownInputsupervisor").style.display =
                          "none";
                        if (e.target.value === "" || !e.target.value) {
                          handleSpanOntop("borderspanTop-HN", false);
                        }
                      }}
                      required
                      onInvalid={(e) => {
                        e.target.setCustomValidity("กรุณาเพิ่มข้อมูล HN ");
                      }}
                      onInput={(e) => {
                        e.target.setCustomValidity("");
                      }}
                    ></input>
                  </div>
                  <div className="inputbox-logbook">
                    <span
                      className="textBorder-logbook"
                      style={
                        datelogbook
                          ? { display: "block", top: "-60%", color: "#2E3136" }
                          : {}
                      }
                    >
                      {"date"}
                    </span>
                    <input
                      type="date"
                      className="inputtext-phaco"
                      value={!datelogbook ? "" : datelogbook}
                      onChange={(e) => {
                        setDatelogbook(e.target.value);
                      }}
                      onInvalid={(e) => {
                        e.target.setCustomValidity("กรุณาเพิ่มข้อมูลวันที่");
                      }}
                      onInput={(e) => {
                        e.target.setCustomValidity("");
                      }}
                      required
                    ></input>
                  </div>
                  <div className="inputbox-logbook" id="aSupervisor">
                    <span
                      className="textBorder-logbook"
                      id={`borderspanTop-supervisor`}
                    >
                      {"supervisor"}
                    </span>
                    <input
                      type="text"
                      className="inputtext-phaco"
                      name="supervisor_phaco"
                      placeholder="supervisor"
                      autoComplete="off"
                      onFocus={(e) => {
                        e.target.select();
                        handleopenDropdownSupervisor(true);
                        if (e.target.value === "" || !e.target.value) {
                          handleSpanOntop("borderspanTop-supervisor", true);
                        }
                      }}
                      onBlur={(e) => {
                        if (!e.target.value) {
                          handleSpanOntop("borderspanTop-supervisor", false);
                        }
                      }}
                      onChange={(e) => {
                        setSupervisor(e.target.value);
                      }}
                      value={supervisor}
                      required={supervisor ? false : true}
                      onInvalid={(e) => {
                        supervisor
                          ? e.target.setCustomValidity(
                              "กรุณาเพิ่มข้อมูล supervisor"
                            )
                          : e.target.setCustomValidity("");
                      }}
                    ></input>
                    <div
                      className="dropdown-inputsupervisor"
                      id="box-dropdownInputsupervisor"
                    >
                      {dataAdvisor.map((ele, index) => {
                        return (
                          <div
                            className="dropdowncard-nameadvisor"
                            key={index}
                            onClick={() => {
                              let nameis = `${ele.ttl.trim()} ${ele.name.trim()} ${ele.lname.trim()}`;
                              setSupervisor(nameis);
                              handleSpanOntop("borderspanTop-supervisor", true);
                              // handleopenDropdownSupervisor(false);
                              getdocId(
                                "box-dropdownInputsupervisor"
                              ).style.display = "none";
                            }}
                          >
                            <span>{`${ele.ttl.trim()} ${ele.name.trim()} ${ele.lname.trim()}`}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="EPA-OOP-box">
                    <input
                      type="checkbox"
                      className="input-checkbox-phaco"
                      onChange={() => {
                        epa === true ? setEpa(false) : setEpa(true);
                      }}
                      checked={epa}
                    ></input>
                    <span style={{ margin: "0 10px" }}>{"EPA,DOP"}</span>
                  </div>
                  <hr></hr>
                  {/* โชว์เมื่อกด EPA OOP เท่านั้น */}
                  {/* ซ้อนตัวเพิ่ม EPA */}
                  <div
                    className="box-infoinput-EPAOOP"
                    style={epa ? { display: "block" } : { display: "none" }}
                  >
                    <div className="inputbox-logbook">
                      <span
                        className="textBorder-logbook"
                        id={`borderspanTop-link`}
                      >
                        {"link"}
                      </span>
                      <input
                        type="text"
                        className="inputtext-phaco"
                        placeholder="link"
                        onChange={(e) => {
                          setLink(e.target.value);
                        }}
                        onFocus={(e) => {
                          handleSpanOntop("borderspanTop-link", true);
                          e.target.select();
                        }}
                        onBlur={(e) => {
                          getdocId(
                            "box-dropdownInputsupervisor"
                          ).style.display = "none";
                          if (e.target.value === "" || !e.target.value) {
                            handleSpanOntop("borderspanTop-link", false);
                          }
                        }}
                        value={link}
                      ></input>
                    </div>
                    <div className="inputbox-logbook">
                      <span
                        className="textBorder-logbook"
                        id={`borderspanTop-file`}
                      >
                        {"file"}
                      </span>
                      <input
                        type="text"
                        className="inputtext-phaco"
                        onClick={() => {
                          document
                            .getElementsByClassName("input-files-phaco")[0]
                            .click();
                        }}
                        onFocus={(e) => {
                          handleSpanOntop("borderspanTop-file", true);
                          e.target.select();
                        }}
                        onBlur={(e) => {
                          getdocId(
                            "box-dropdownInputsupervisor"
                          ).style.display = "none";
                          if (e.target.value === "" || !e.target.value) {
                            handleSpanOntop("borderspanTop-file", false);
                          }
                        }}
                        value={file[0] ? file[0].name : ""}
                        placeholder="file..."
                        readOnly
                      ></input>
                      <input
                        type="file"
                        style={{ display: "none" }}
                        className="input-files-phaco"
                        accept=".pdf"
                        onChange={(e) => {
                          setFile(e.target.files);
                        }}
                      ></input>
                    </div>
                  </div>
                </div>
              </div>

              <hr style={epa ? { display: "block" } : { display: "none" }}></hr>
              <div className="footer-formcontent">
                <div
                  className="box-btnSubmitcancle-logbook"
                  id="submitcancleBTN"
                >
                  {/* <button
                    className="btnCancle-footer-formcontent"
                    type="button"
                    onClick={() => {
                      handleClearInputLogbook();
                    }}
                  >{`ยกเลิก`}</button> */}
                  <button
                    className="btnConfirm-footer-formcontent"
                    type="submit"
                  >{`เพิ่ม`}</button>
                </div>
                <div>
                  <button
                    className="btnDownAddlogbook"
                    id="btn-downOpenlogbook"
                    type="button"
                    onClick={() => {
                      handleopenInputlogbook(
                        "animationLogbook",
                        "boxinputLogbook",
                        true
                      );
                    }}
                  >
                    <i className="bi-caret-down"></i>
                  </button>
                  <button
                    className="btnUpAddlogbook"
                    id="btn-upCloselogbook"
                    type="button"
                    onClick={() => {
                      handleopenInputlogbook(
                        "animationLogbook",
                        "boxinputLogbook",
                        false
                      );
                      handleClearInputLogbook();
                    }}
                  >
                    <i className="bi-caret-up"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="box-status-phaco">
          <div className="card-content-phaco">
            <div className="showinfocard-reqEpa-residentLogbook">
              <div className="status-cardcontent-phaco">
                <div className="head-status-info">
                  <b>
                    <span>{`phaco`}</span>
                  </b>
                  <div>
                    <div
                      className="status-showing"
                      style={{ backgroundColor: "#e0e0e0", color: "#928880" }}
                    >
                      <span>{`EPA ?`}</span>
                    </div>
                  </div>
                </div>
                <div className="req-status-info">
                  <b>
                    <span>{`requirement :`}</span>
                  </b>
                  <span
                    style={{ color: "#CFCAC7" }}
                  >{`${dataforTableshow.length} / 20`}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="box-showlist-topicinfo">
          {/* <div className="div-showtable-topic-info">
            <div className="headbar-showtable-topic-info">
              <span>{"list logbook"}</span>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  console.log("this searchLogbooklist", listlogbookFilter);

                  if (listlogbookFilter) {
                    setDataforsearchshow(
                      searchlistLogbookdetail(
                        listlogbookFilter,
                        dataforTableshow
                      )
                    );
                  } else {
                    setDataforsearchshow([]);
                  }
                }}
              >
                <div className="search-filter-listlogbook">
                  <div className="icon-searchlistlogbook">
                    <i className="bi-search"></i>
                  </div>
                  <input
                    className="inputsearch-searchlistlogbook"
                    type="text"
                    autoComplete="off"
                    value={listlogbookFilter}
                    onChange={(e) => {
                      setListlogbookFilter(e.target.value);
                    }}
                    onFocus={(e) => e.target.select()}
                  ></input>
                  <button type="submit" style={{ display: "none" }}></button>
                </div>
              </form>
            </div>
            <div className="curentboxinfo-listlogbook">
              {dataforsearchshow[0] ? (
                dataforsearchshow.map((data, index) => {
                  return (
                    <div className="aboxbodyinfo-listlogbook" key={index}>
                      <div className="box-info-listlogbook headboxinfo-listlogbook">
                        {data.epa ? (
                          <>
                            <span>{"EPA"}</span>
                            <span>{data.epa}</span>
                          </>
                        ) : (
                          <>
                            <span>{"HN"}</span>
                            <span>{data.hn}</span>
                          </>
                        )}
                      </div>
                      {data.epa ? (
                        <div className="box-info-listlogbook">
                          <span className="headinfo-infolistlogbook">
                            {"HN"}
                          </span>
                          <span className="textinfo-infolistlogbook">
                            {data.hn}
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                      <div className="box-info-listlogbook">
                        <span className="headinfo-infolistlogbook">
                          {"date"}
                        </span>
                        <span className="textinfo-infolistlogbook">
                          {data.date}
                        </span>
                      </div>
                      <div className="box-info-listlogbook">
                        <span className="headinfo-infolistlogbook">
                          {"supervisor"}
                        </span>
                        <span className="textinfo-infolistlogbook">
                          {data.supervisor}
                        </span>
                      </div>
                      {data.link ? (
                        <div className="box-info-listlogbook">
                          <span className="headinfo-infolistlogbook">
                            {"link"}
                          </span>
                          <span className="textinfo-infolistlogbook">
                            {data.link}
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                      {data.file ? (
                        <div className="box-info-listlogbook">
                          <span className="headinfo-infolistlogbook">
                            {"file"}
                          </span>
                          <span className="textinfo-infolistlogbook">
                            {data.file}
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  );
                })
              ) : dataforTableshow[0] ? (
                dataforTableshow.map((data, index) => {
                  return (
                    <div className="aboxbodyinfo-listlogbook" key={index}>
                      <div className="box-info-listlogbook headboxinfo-listlogbook">
                        {data.epa ? (
                          <>
                            <span>{"EPA"}</span>
                            <span>{data.epa}</span>
                          </>
                        ) : (
                          <>
                            <span>{"HN"}</span>
                            <span>{data.hn}</span>
                          </>
                        )}
                      </div>
                      {data.epa ? (
                        <div className="box-info-listlogbook">
                          <span className="headinfo-infolistlogbook">
                            {"HN"}
                          </span>
                          <span className="textinfo-infolistlogbook">
                            {data.hn}
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                      <div className="box-info-listlogbook">
                        <span className="headinfo-infolistlogbook">
                          {"date"}
                        </span>
                        <span className="textinfo-infolistlogbook">
                          {data.date}
                        </span>
                      </div>
                      <div className="box-info-listlogbook">
                        <span className="headinfo-infolistlogbook">
                          {"supervisor"}
                        </span>
                        <span className="textinfo-infolistlogbook">
                          {data.supervisor}
                        </span>
                      </div>
                      {data.link ? (
                        <div className="box-info-listlogbook">
                          <span className="headinfo-infolistlogbook">
                            {"link"}
                          </span>
                          <span className="textinfo-infolistlogbook">
                            {data.link}
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                      {data.file ? (
                        <div className="box-info-listlogbook">
                          <span className="headinfo-infolistlogbook">
                            {"file"}
                          </span>
                          <span className="textinfo-infolistlogbook">
                            {data.file}
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  );
                })
              ) : (
                <div className="aboxbodyinfo-listlogbook">
                  <div className="box-info-listlogbook headboxinfo-listlogbook">
                    <span className="headinfo-infolistlogbook">{"HN"}</span>
                    <span className="textinfo-infolistlogbook">{"-"}</span>
                  </div>
                  <div className="box-info-listlogbook">
                    <span className="headinfo-infolistlogbook">{"date"}</span>
                    <span className="textinfo-infolistlogbook">{"-"}</span>
                  </div>
                  <div className="box-info-listlogbook">
                    <span className="headinfo-infolistlogbook">
                      {"supervisor"}
                    </span>
                    <span className="textinfo-infolistlogbook">{"-"}</span>
                  </div>
                </div>
              )}
            </div>
          </div> */}
          <table className="table-topicshowinfomation">
            <thead>
              <tr>
                <th>{"No."}</th>
                <th>{"HN"}</th>
                <th>{"Date"}</th>
                <th>{"Sup"}</th>
              </tr>
            </thead>
            <tbody>
              {dataforTableshow[0] ? (
                dataforTableshow.map((ele, index) => {
                  return (
                    <tr
                      key={index}
                      style={
                        ele.epa
                          ? {
                              color: "#AA7C7A",
                              fontWeight: "bold",
                              textShadow: "2px 5px 10px #AA7C7A",
                            }
                          : {}
                      }
                      onClick={() => {
                        console.log("test กดแล้วครับ", ele);
                        handleOpenModalinfomation(ele);
                      }}
                    >
                      <td>{ele.no}</td>
                      <td>{ele.hn}</td>
                      <td>
                        {moment(
                          new Date(
                            `${ele.date.split("/")[1]}/${
                              ele.date.split("/")[0]
                            }/${ele.date.split("/")[2]}`
                          )
                        )
                          .add("543", "year")
                          .format("DD/MM/YY")}
                      </td>
                      <td className="td-nameSupervisor">{`${
                        ele.supervisor.split(" ")[1]
                      } ${ele.supervisor.split(" ")[2]}`}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td>{"-"}</td>
                  <td>{"-"}</td>
                  <td>{"-"}</td>
                  <td>{"-"}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <ModalConfig
        idbox={"modalbox-infomationLogbook"}
        width={"90%"}
        height={"auto"}
        bgcolor={"#fffefe"}
        content={AcontentShowinfomodal()}
      ></ModalConfig>
    </div>
  );
};
export default Logbook;
